<template>
  <div class="threejsContainer">
    <div class="containerTitle">1-3.着色器 顶点着色器-涟漪-半屏(单场景、双相机、双渲染器)</div>
    <div ref="container1" class="containerHalfBody"></div>
    <div ref="container2" class="containerHalfBody"></div>
  </div>
</template>

<script>
import * as THREE from 'three';
import {initGUI} from './components/datgui.js';
import {generateScene} from '@/threejsEnv/scene.js';
import {genPerspectiveCamera} from '@/threejsEnv/camera.js';
import {genOrthographicCamera} from '@/threejsEnv/camera.js';
import {genRenderer} from '@/threejsEnv/renderer.js';
import {generateShader} from './components/shader';

export default {
  data(){
    return {
      scene:null,
      camera1:null, 
      renderer1:null, 
      camera2:null, 
      renderer2:null, 
      plane:null,
      points:null,
      u_time:0,
      gui:null,
      animationId:null,
      guiParams: {
        pointer: true 
      },
      window:{
        width: 0,
        height: 0
      }
    }
  },
  created(){
    this.window.width = window.innerWidth/2.0;
    this.window.height = window.innerHeight;
  },
  mounted(){

    this.scene = generateScene();
    
    this.camera1 = genPerspectiveCamera(this.window)
    this.camera2 = genOrthographicCamera(this.window);

    this.renderer1 = genRenderer(this.window); 
    this.renderer2 = genRenderer(this.window); 

    this.$refs.container1.appendChild(this.renderer1.domElement);
    this.$refs.container2.appendChild(this.renderer2.domElement);
    //引用，主要用于销毁
    this.gui = initGUI(this.camera2);
    this.initPanel();
    this.render();
    //添加监听
    window.addEventListener('resize', this.onWindowResize);
  },
  methods:{
    initPanel(){
      const planeGeometry = new THREE.PlaneGeometry(5, 5, 80, 80);
      const shaderMaterial = generateShader();
      
      this.points = new THREE.Points(planeGeometry, shaderMaterial);

      // 5. 【关键】将 Points 对象也进行同样的旋转，使其与平面完全重合
      this.points.rotation.x = -Math.PI / 2.0;

      // 6. 将 Points 对象添加到场景中
      this.scene.add(this.points);
    },
    render() {
      this.renderer1.render(this.scene, this.camera1);
      this.renderer2.render(this.scene, this.camera2);
			this.points.rotation.z -= 0.001;
      this.u_time+=0.02;
      this.points.material.uniforms.u_time.value = this.u_time;
      this.camera1.lookAt(this.scene.position);
      this.camera2.lookAt(this.scene.position);
      //引用，主要用于销毁
      this.animationId = requestAnimationFrame(this.render);
    },
    onWindowResize(){
        const container1 = this.$refs.container1;
        const width = container1.clientWidth;
        const height = container1.clientHeight;

        // 1. 更新相机的宽高比 (aspect)
        this.camera1.aspect = width / height;
        // 【关键】更新相机的投影矩阵，使更改生效
        this.camera1.updateProjectionMatrix();
        this.camera2.aspect = width / height;
        this.camera2.updateProjectionMatrix();

        // 2. 更新渲染器的尺寸
        this.renderer1.setSize(width, height);
        this.renderer2.setSize(width, height);
    }
  },
  beforeDestroy(){
    cancelAnimationFrame(this.animationId);
    this.gui.destroy();
    this.renderer1.dispose(); // 释放渲染器内存
    this.renderer1.domElement.remove(); // 从 DOM 中移除 canvas 元素
    this.renderer2.dispose(); // 释放渲染器内存
    this.renderer2.domElement.remove(); // 从 DOM 中移除 canvas 元素
  },
  destroyed(){
    this.scene = null;
    this.camera1 = null;
    this.renderer1 = null;
    this.camera2 = null;
    this.renderer2 = null;
    this.gui=null;
  }
}
</script>

<style scoped>
.threejsContainer{
  display: flex;
}
</style>